/**
 * @module AlpineComponents
 * @description Central registry and initialization for Alpine.js
 */

import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import focus from '@alpinejs/focus';
import TechTransferSearchGrid from './search/TechTransferSearchGrid.js';

Alpine.plugin(intersect);
Alpine.plugin(focus);

// Make Alpine available globally
window.Alpine = Alpine;

// Register components
Alpine.data('techTransferSearch', TechTransferSearchGrid);

// Initialize Alpine (only once — guards against HMR double-init)
function initAlpine() {
  if (window.__alpineStarted) return;
  Alpine.start();
  window.__alpineStarted = true;
}

initAlpine();

export { Alpine, TechTransferSearchGrid };
